import React from 'react';

export default function Footer() {
  const style = {
    fontSize: '0.8rem',
    color: '#4a4a4a',
    textAlign: 'center',
    padding: '16px 0',
    minHeight: '40px',
  };
  return (
    <footer>
      <div style={style}>
        Source: IEA, 2026 Energy Crisis Policy Response Tracker
      </div>
    </footer>
  );
}
